
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHd5Grid extends Serenity.EntityGrid<PsAdvPromoHd5Row, any> {
        protected getColumnsKey() { return PsAdvPromoHd5Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHd5Dialog; }
        protected getIdProperty() { return PsAdvPromoHd5Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHd5Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHd5Row.localTextPrefix; }
        protected getService() { return PsAdvPromoHd5Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;

        }
    }
}